// @ts-nocheck a0068b33
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_selection_tags'],
      sections: [
        addPanel.sections.getSections().developer.selectionTagsListSection,
      ],
    };
  },
};
